import { render, staticRenderFns } from "./CaseConversations.vue?vue&type=template&id=3ca45d3e"
import script from "./CaseConversations.vue?vue&type=script&lang=js"
export * from "./CaseConversations.vue?vue&type=script&lang=js"
import style0 from "./CaseConversations.vue?vue&type=style&index=0&id=3ca45d3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports